import { render, staticRenderFns } from "./TaskAssignment.vue?vue&type=template&id=5e270417&scoped=true"
import script from "./TaskAssignment.vue?vue&type=script&lang=js"
export * from "./TaskAssignment.vue?vue&type=script&lang=js"
import style0 from "./TaskAssignment.vue?vue&type=style&index=0&id=5e270417&prod&scoped=true&lang=css"
import style1 from "./TaskAssignment.vue?vue&type=style&index=1&id=5e270417&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e270417",
  null
  
)

export default component.exports